import Vue from 'vue';
import moment from 'moment';
import ApiRequest from '@/tools/ApiRequest';
import RequestException from '@/tools/helpers/RequestException';

export type LuckyNumber = {
  id: number;
  invoice_id: number;
  number: string;
  created_at: number;
};

export default Vue.extend({
  name: 'LuckyNumbers',
  data: () => ({
    luckyNumbers: [] as LuckyNumber[],
  }),
  methods: {
    getInvoices(): void {
      ApiRequest.getLuckyNumbers()
        .then((response) => {
          this.luckyNumbers = response.data;
        })
        .catch((error) => new RequestException(error, this.$store, this.$router));
    },
    formatDate(time: number): string {
      return moment.unix(time).format('DD/MM/YYYY HH:mm');
    },
  },
  created(): void {
    this.getInvoices();
  },
});
